var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"has-background-white pa-xl has-text-centered rounded-xl"},[_vm._v(" Payment Reporting ")])])])
}]

export { render, staticRenderFns }